declare global {
  interface Window {
    env?: {
      REACT_APP_ENV?: string
      STRIPE_ACCOUNT?: string
      FORDPAY_SCRIPT_URL_DEV?: string
      FORDPAY_SCRIPT_URL_PROD?: string
      APIGEE_BASE_URL?: string
      HERE_MAP_GEOCODE_API?: string
      HERE_MAP_API_KEY?: string
      DEBUG_LOG?: string
    }
  }
}

const environment = {
  REACT_APP_ENV:
    window.env?.REACT_APP_ENV ?? process.env?.REACT_APP_ENV ?? 'dev',
  STRIPE_ACCOUNT:
    window.env?.STRIPE_ACCOUNT ??
    process.env?.STRIPE_ACCOUNT ??
    'acct_1LJ1zfCfn25WxNXd',
  FORDPAY_SCRIPT_URL_DEV:
    window.env?.FORDPAY_SCRIPT_URL_DEV ??
    process.env?.FORDPAY_SCRIPT_URL_DEV ??
    'https://fordpay-components-uat.ford.com/js/fordpay-ui-checkout-bundle.js',
  FORDPAY_SCRIPT_URL_PROD:
    window.env?.FORDPAY_SCRIPT_URL_PROD ??
    process.env?.FORDPAY_SCRIPT_URL_PROD ??
    'https://fordpay-components.ford.com/js/fordpay-ui-checkout-bundle.js',
  APIGEE_BASE_URL:
    window.env?.APIGEE_BASE_URL ??
    process.env?.APIGEE_BASE_URL ??
    'https://api-dev.fordpro.com',
  HERE_MAP_GEOCODE_API:
    window.env?.HERE_MAP_GEOCODE_API ??
    process.env?.HERE_MAP_GEOCODE_API ??
    'https://geocode.search.hereapi.com/v1',
  HERE_MAP_API_KEY:
    window.env?.HERE_MAP_API_KEY ??
    process.env?.HERE_MAP_API_KEY ??
    'Ij9nlvM6icpauSrkohS4yCNbF-AyYJZ0IiTp_Gvgbbs',
  DEBUG_LOG: window.env?.DEBUG_LOG ?? 'false',
}

export default environment
